'use strict';

var html = document.getElementsByTagName('html')[0],
	lang = html.getAttribute('lang'),
	main = document.querySelector('script[data-main]'),
	base = (main.dataset === undefined ? main.getAttribute('data-base') : main.dataset.base) || ''
;
requirejs.config({
	assetBase: base,
	baseUrl: base + '/js/',
	// disable cache for development !!!
	 urlArgs: 'no_cache='+ (+new Date()),
	//urlArgs: '',

	// requirejs i18n plugin
	// If `locale` is not set it will be set to `navigator.languages[0] || navigator.language || navigator.userLanguage` by i18n
	locale: lang,

	paths: {
		'i18n': '3rdparty/i18n',
		'PEP': '3rdparty/pep.0.4.2',
	},
	// `map` and `shim` must be the same as in grunt/tasks/requirejs.js
	map: {
		'*': {
			'jQuery': 'jquery',
			'Modernizr': 'modernizr',
		},
	},
	shim: {
		'modernizr': {
			exports: 'Modernizr',
		},
		'3rdparty/jquery.picture': {
			exports: 'jQuery.fn.picture',
		},
		'3rdparty/jquery.magnific-popup': {
			exports: 'jQuery.magnificPopup',
		},
	},
});

// Google Maps API
var gmapApi = {
	lang: lang,
	key: (main.dataset === undefined ? main.getAttribute('data-google-maps-api-key') : main.dataset.googleMapsApiKey) || '',
};
define('GoogleMapsApi', ['gmaps-api'], function() {
	/* globals google:true */
	return window.google.maps;
});



require([
	'core',
	'core/helper/Utilities'
], function (Core, Utilities) {
	requirejs.config({
		map: {
			'*': {
				'gmaps-api': '//maps.googleapis.com/maps/api/js?'+ Utilities.buildQueryString(gmapApi),
			}
		},
		shim: {
			'gmaps-api': {
				exports: 'window.google.maps',
			},
		},
	});
});

require(['3rdparty/custom-file-input']);

// Always load CookieHint
//require(['modules/CookieHint']);
require(['modules/CookieNotice']);
define("main", function(){});

